<template>
  <RouterView />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useAuthStore } from './stores/auth'
import { useSettingsStore } from './stores/settings'
import { APP_NAME } from './config/brand'

const authStore = useAuthStore()
const settingsStore = useSettingsStore()

const brandTitle = computed(() => {
  if (!authStore.isAuthenticated) {
    return APP_NAME
  }
  const subdivision = settingsStore.data?.subdivision?.trim()
  return subdivision ? `${subdivision} - ${APP_NAME}` : APP_NAME
})

watch(
  () => authStore.isAuthenticated,
  (isAuthenticated) => {
    if (isAuthenticated && !settingsStore.data && !settingsStore.loading) {
      settingsStore.get().catch(() => undefined)
    }
  },
  { immediate: true },
)

watch(
  brandTitle,
  (value) => {
    document.title = value
  },
  { immediate: true },
)
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
